<div class="p-grid">
  <div class="p-col p-field">
      <label for="username">Escriba el email para enviar la prueba</label>
      <input id="username" type="username" pInputText [(ngModel)]="marketingTest.email" placeholder="nombre@email.com" />  
  </div>
</div>
<div class="p-grid" *ngIf="errorMessage!=''">
  <div class="p-col">
      <p-message severity="error" text="{{errorMessage}}" class="p-d-block"></p-message>
  </div>
</div>
<div class="p-grid">
  <div class="p-col">
      <button class="p-ml-2" style="float: right;" pButton type="button" label="Enviar email prueba" (click)="send()"></button>
      <button pButton class="p-button-link p-button-secondary" style="float: right;" (click)="cancel()" icon="pi pi-times" label="Cancelar"></button>
  </div>
</div>